import Cookies from "js-cookie";

export default async function(app_uri) {
    console.log('Отправляю запрос проверки доступа ...')
    console.warn(`Приложение: ${app_uri}`)
    let url = `${window.config.SSL}://${window.config.ONEADDRESS}/${window.config.BASE}/${window.config.ONETEST}/TOOL_CheckAccess`
    let body = {
        app: window.config.WS_APP,
        tool_url: app_uri
    }
    let config = {
        method: 'POST',
        withCredentials: true,
        headers: {
            "Authorization": "Bearer " + Cookies.get('token')
        },
        body: JSON.stringify(body)
    }

    return new Promise((resolve) => {
        fetch(url, config)
            .then(async response => {
                if (!response.ok) {
                    throw `Ошибка получения списка приложений`
                }
                return await response.json()
            })
            .then(async result => {
                console.log(result)
                if (result) {
                    if (result.access) {
                        resolve(true)
                    } else {
                        resolve(false)
                    }
                } else {
                    resolve(false)
                }
            }).catch(err => {
            console.error(err)
        })
    })
}
